import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content'

const alert = withReactContent(Swal);

// const sa = alert.mixin({
//     customClass: {
//         confirmButton: 'py-2 px-4 rounded-lg text-xs font-semibold border-2 border-blue-700 bg-blue-700 text-white hover:bg-blue-900 hover:border-blue-900',
//         cancelButton: 'py-2 px-4 rounded-lg text-xs font-semibold border-2 border-gray-500 hover:border-red-500 text-gray-800 hover:bg-red-400 hover:text-red-800',
//         closeButton: 'py-2 px-4 rounded-lg text-xs font-semibold border-2 border-gray-500 hover:border-red-500 text-gray-800 hover:bg-red-400 hover:text-red-800',
//     },
//     buttonsStyling: false
// })


export const showAlert = async  ( icon = 'success' , title, message, cb) => {
     await alert.fire({
         icon: 'success',
         title: title,
         text: message,
         showCancelButton: false,
         confirmButtonText: 'Ok',
         cancelButtonText: 'No, cancel!',
     }).then((result) => {
         if (result.isConfirmed) {
            cb();
         }
     })
}

export const warningAlert = async (title, message, cb) => {
    await alert.fire({
        icon: 'warning',
        title: title,
        text: message,
        showCancelButton: true,
        confirmButtonText: 'Yes Continue!',
        cancelButtonText: 'No, cancel!',
    }).then((result) => {
        if (result.isConfirmed) {
            cb();
        }
    })
}

    // await alert.fire({
    //     icon: type,
    //     title: title,
    //     text: message,
    //     customClass: {
    //         container: '...',
    //         popup: '...',
    //         header: '...',
    //         title: '...',
    //         closeButton: 'py-2 px-4 rounded-lg text-xs font-semibold border-2 border-gray-500 hover:border-red-500 text-gray-800 hover:bg-red-400 hover:text-red-800',
    //         icon: '...',
    //         image: '...',
    //         htmlContainer: '...',
    //         input: '...',
    //         inputLabel: '...',
    //         validationMessage: '...',
    //         actions: '...',
    //         confirmButton: 'py-2 px-4 rounded-lg text-xs font-semibold border-2 border-blue-700 bg-blue-700 text-white hover:bg-blue-900 hover:border-blue-900',
    //         denyButton: '...',
    //         cancelButton: 'py-2 px-4 rounded-lg text-xs font-semibold border-2 border-gray-500 hover:border-red-500 text-gray-800 hover:bg-red-400 hover:text-red-800',
    //         loader: '...',
    //         footer: '....',
    //         timerProgressBar: '....',
    //     }
        
    // });